import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myParams: null
  },
  getters: {
  },
  mutations: {
    setMyParams(state, params) {
      state.myParams = params;
    }
  },
  actions: {
  },
  modules: {
  }
})
